"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceShow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const invoice_1 = require("../../../model/invoice");
const helpers_1 = require("../../../utils/helpers");
const right_panel_1 = require("../../../widgets/right_panel");
const invoice_print_1 = require("./invoice_print");
exports.InvoiceShow = {
    invoice: {},
    oncreate(vnode) {
        let id = vnode.attrs.id;
        if (id != this.invoice.id) {
            this.invoice = {};
            invoice_1.InvoiceProvider.show(id).then((invoice) => { this.invoice = invoice; });
        }
    },
    view(_vnode) {
        if (this.invoice.client === undefined) {
            return undefined;
        }
        return (0, mithril_1.default)("div", { class: "content" }, (0, mithril_1.default)("h2", `Facture #${this.invoice.id}`), (0, mithril_1.default)("hr"), (0, mithril_1.default)("a", { class: "button is-primary", href: invoice_print_1.InvoicePrint.link(this.invoice.id), target: "_blank" }, (0, helpers_1.iconSpan)("fa-print"), (0, mithril_1.default)("span", "Imprimer")), (0, helpers_1.renderProperties)({
            "Identifiant unique": this.invoice.reference,
            "Contrat": (0, helpers_1.tag)(right_panel_1.RightPanel.linkTo(this.invoice.contract.name, "contracts", this.invoice.contract.id)),
            "Client": right_panel_1.RightPanel.linkTo(this.invoice.client.name, "clients", this.invoice.client.id, "show")
        }));
    }
};
